import TabGroupRoot, { Props } from './TabGroup'

export default function TabGroup(props: Props) {
  return <TabGroupRoot {...props} />
}
